export enum LogsFamilyEnum {
    Application = 0,
    Machine = 1,
}

export function logsFamilyEnumLabel(value: LogsFamilyEnum): string {
    switch (value) {
        case LogsFamilyEnum.Application:
            return "downloadLogs.applicationLogs";
        case LogsFamilyEnum.Machine:
            return "downloadLogs.machinesLogs";
        default:
            return "common.unknown";
    }
}

export function getName(value: LogsFamilyEnum): string {
    switch (value) {
        case LogsFamilyEnum.Application:
            return "application";
        case LogsFamilyEnum.Machine:
            return "machine";
        default:
            return "common.unknown";
    }
}
